import React from "react";

import PrivateRoute, { PrivateRouteProps } from "../../hoc/private-route";

const GeneratorRoute: React.FC<PrivateRouteProps> = (props) => {
    return <PrivateRoute {...props} />;
};

export default GeneratorRoute;
